import { render, staticRenderFns } from "./HeaderRegister3.vue?vue&type=template&id=26967d3e&scoped=true"
import script from "./HeaderRegister3.vue?vue&type=script&lang=ts"
export * from "./HeaderRegister3.vue?vue&type=script&lang=ts"
import style0 from "./HeaderRegister3.vue?vue&type=style&index=0&id=26967d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26967d3e",
  null
  
)

export default component.exports